<app-nav-pages></app-nav-pages>
<section class="hero-section d-flex justify-content-between align-items-top flex-column  csr-hero">
  <div class="overlay"></div> 
  <div class="hero-text d-flex align-items-center flex-grow-1 justify-content-center  flex-column gap-5 ">
    <h3 #textContent>THE ELITES RESIDENCE</h3>
    <h4 #textContent>Limited Collections</h4>
  </div> 

  <section class="d-flex elites_tag_line justify-content-between f-c ">
    <div class="hero-text pb-2 wo-100" #leftReveal>
      <h2>GREATNESS HAS AN ADDRESS</h2>
    </div>
    <div class=" cl-light elites_hero_mssg wo-100" #rightReveal>
      <h4>The Elite Residence Concept</h4>
      <p>The Elite Residence is a beautiful, gated community—a quiet and private neighborhood designed for successful people. Think of it as <b>Banana Island in Benin City.</b></p>
    </div>
  </section>
</section>

<main>
 

  <section class="w-100">
    <!-- <advanced-image [cldImg]="elitesImage2" width="100%"></advanced-image> -->
    <img src="assets/imgs/elites/full_landscape.webp" alt="Facade loading..." class="w-100 ">
  </section>

  <section class="the_vision">
    <div class="container d-flex flex-column w-50 mx-auto  align-items-center mb-5 wo-100">
      <div class="w-100">
        <img src="assets/imgs/elites_logo.png" class="img-fluid " alt="">
      </div>
      <article class="w-100 my-5  ">
        <h3 class="mb-3" #textContent>THE VISION</h3>
    
        <div class="d-flex mb-5">
          <div class="vision_text" #textContent>
            <p>We are building a special place for achievers, created by achievers—a home that matches the dreams and lifestyle of its residents.</p>
          </div>
          
        </div>
        
        <h3 class="mb-3" #textContent>THE APPROACH</h3>
        <div class="d-flex">
          <div class="vision_text" #textContent>
            <p>We know that everyone is unique, so we make sure each home can be personalized to fit different tastes and needs.
              Using modern technology and timeless designs, we create homes that are not just places to live, but symbols of success, comfort, and beauty.
            </p>
      
          </div>
          
        </div>
        
      </article>
     
    
      <article class="w-100" #textContent>
        <!-- <advanced-image [cldImg]="elitesImage3" width="100%"></advanced-image> -->
        <img src="assets/imgs/elites/pg1.webp" alt="Facade loading..." class="img-fluid">
      </article>

      <article class="quote_2 " #textContent>
        <p>"Every community should have an address for greatness. Not just to reflect your identity but also to inspire you to do more, to be more and to make a difference in your community."</p>
        <div class="quote-owner d-flex flex-column text-end ">
          <p class="mt-5 fs-1 quote-owner mt-5">Lucky R. Erherha</p>
          <p class=" fs-4 title">Founder & CEO, Zumera.</p>
        </div>
      </article>
  
    </div>
  </section> 
  
  <section class="w-100" #textContent>
    <!-- <advanced-image [cldImg]="elitesImage1" width="100%"></advanced-image> -->
    <img src="assets/imgs/elites_2.jpg" alt="" class="img-fluid">
  </section> 

  <section class="the_design">
    <div class="container d-flex flex-column w-50 mx-auto  align-items-center mb-5 wo-100">
      <article  class="w-100 my-5  ">
        <h3 class="mb-3" #textContent>THE DESIGN</h3>
        <div class="d-flex mb-5">
          <div class="vision_text" #textContent>
            <p>Our design is built on three important ideas:</p>

            <p> ✔ Elegance– Homes that look stylish and luxurious. <br>
                ✔ Comfort – Spaces that feel just right for living. <br>
                ✔ Personalization – Features that can be customized for each resident.</p>

            <p>Every detail is carefully chosen to make life extraordinary. With modern features and the best materials, our homes offer the perfect blend of luxury and convenience.</p>
          </div>
        </div>
  
        <h3 class="mb-3" #textContent>THE PROJECT</h3>
        <h4 #textContent>The Elite Residence is a high-end neighborhood that offers first-class comfort and luxury.</h4>
        <div class="d-flex">
          <div class="vision_text" #textContent>
            <p>Located next to the famous Zumera Tower, this community includes: <br>  
              - Six stunning duplex penthouses   <br>
              - Spacious six-bedroom apartments <br>
              - Private jacuzzis & beautiful swimming pools <br>
              - Home cinemas & rooftop lounges   <br>
              - Modern fitness centers <br>
              - Top-class amenities for an exceptional lifestyle
              </p>  
          </div>
        </div>
      </article>
      
      <section class="w-100" #textContent>
        <!-- <advanced-image [cldImg]="elitesImage4" width="100%"></advanced-image> -->
        <img src="assets/imgs/elites/Pg2.webp" alt="" class="w-100">
      </section>
      
      <section class="vision_text vision_text_2 mt-5 " #textContent>
        <p>The Elite neighborhood mirrors the opulence of Banana Island in Lagos and the splendor of Guzape in Abuja. We are meticulously crafting the most luxurious residence in Benin City, setting a new standard for sophistication and elegance.</p>
      </section>
    </div>
  </section>

  <section>
    <h2 class="text-center interior mb-5" #textContent>INTERIORS</h2>
  
    <section class="splide" aria-label="Splide Basic HTML Example" #textContent>
      <div class="splide__track">
        <ul class="splide__list">

          <li class="splide__slide">
            <div class=" d-flex flex-column justify-content-center gap-3 ">
              <div class="slide_img w-100">
                <img src="assets/imgs/elites_interiors/bedroom.jpg" alt="" class="img-fluid">
                <!-- <advanced-image [cldImg]="interior3" width="100%"></advanced-image> -->
              </div>
            </div>
          </li>

          <li class="splide__slide">
            <div class=" d-flex flex-column justify-content-center gap-3 ">
              <div class="slide_img w-100">
                <img src="assets/imgs/elites_interiors/cinema.jpg" alt="" class="w-100 ">
                <!-- <advanced-image [cldImg]="interior2" width="100%"></advanced-image> -->
              </div>
            </div>
          </li>

          <li class="splide__slide">
            <div class=" d-flex flex-column justify-content-center gap-3 ">
              <div class="slide_img w-100">
                <!-- <advanced-image [cldImg]="interior4" width="100%"></advanced-image> -->
                <img src="assets/imgs/elites_interiors/dining.jpg" alt="" class="img-fluid">
              </div>
            </div>
          </li>

          <li id="test" class="splide__slide" #test>
            <div class=" d-flex flex-column justify-content-center gap-3 ">
              <div class="slide_img w-100">
                <!-- <advanced-image [cldImg]="interior1" width="100%"></advanced-image> -->
                <img src="assets/imgs/elites_interiors/kitchen.jpg" alt="" class="img-fluid">
              </div>
            </div>
          </li>

          <li class="splide__slide">
            <div class=" d-flex flex-column justify-content-center gap-3 ">
              <div class="slide_img w-100">
                <!-- <advanced-image [cldImg]="interior6" width="100%"></advanced-image> -->
                <img src="assets/imgs/elites_interiors/living.jpg" alt="" class="img-fluid">
              </div>
            </div>
          </li>

          <li class="splide__slide">
            <div class=" d-flex flex-column justify-content-center gap-3 ">
              <div class="slide_img w-100">
                <!-- <advanced-image [cldImg]="interior7" width="100%"></advanced-image> -->
                <img src="assets/imgs/elites_interiors/office2.jpg" alt="" class="img-fluid">
              </div>
            </div>
          </li>


        </ul>
      </div>
    </section>
  </section>

</main>


<section class="text-center next " #textContent>
  
  <h3 class="quote_3">&ldquo;A residence for those who are shaping our communities.&rdquo;</h3>

  <section class="container d-flex gap-5 justify-content-between f-c wo-100">
    <div class="wo-100 _contact_img">
      <!-- <advanced-image [cldImg]="contactImg" width="100%"></advanced-image> -->
      <img src="assets/imgs/elites/Pg3.webp" alt="elite compound" class="img-fluid">
    </div>
    <div class="wo-100 d-flex align-items-start _contact text-start  justify-content-center flex-column ">
      <h3> Own a Home at The Elite Residence</h3>
      <p>Our team is here to help you <b>buy or invest with ease.</b></p>
      <p><b>Contact Zumera Property today</b> for inquiries or early registration. <b>Your dream home is waiting!</b></p>
      <div class="contact_us d-flex gap-3 ">
        <a href="tel:+2347046626460" class="know-more-btn">
          CALL &#8594;
        </a>
        <a href="mailto:enquiry@zumeraproperty.com" class="know-more-btn">
          MAIL  &#8594;
        </a>
      </div>
      
    </div>
  </section>

  <p class="quote_3_p">NEXT &#8594;</p>
  <h4 class="mb-3" #textContent>The Elites Residence Features & Amenities</h4>
  <a href="" class="know-more-btn">KNOW MORE</a>
</section>

<section class="flex-column" >
  <div class="container">
    <div class="our_project_header ">
      <h2 class="text-center ">Other Projects You May Like</h2>
      <h2 class="welcome_mssg mssg_2 " >Crafting The Highest Standard, Innovative Products and The Most Valuable Environments For You.</h2>
    </div>
    <div class="our_project  mx-auto ">
      <div id="ourProjects" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-inner our_project_carousel_inner mx-auto ">
          <div class="carousel-item active">
            <img src="assets/imgs/facade_2.jpg" class="d-block w-100" alt="...">

            <div class="know-more d-flex justify-content-between align-items-center  ">
              <h3 class="rdj_bold"><b>ZUMERA TOWER.</b></h3>
              
              <a href="https://zumeratower.com" class="know-more-btn" (mouseenter)="onMouseColorChange('white')" (mouseleave)="onChangeColorBack('#8d0a1f')">KNOW MORE</a>
            </div>
          </div>

          <div class="carousel-item">
            <img src="assets/imgs/queen_idia.jpg" class="d-block w-100" alt="...">

            <div class="know-more d-flex justify-content-between align-items-center ">
              <h3 class="rdj_bold"><b>QUEEN IDIA RESIDENCE. </b></h3>
              
              <a href="#" class="know-more-btn" (mouseenter)="onMouseColorChange('white')" (mouseleave)="onChangeColorBack('#8d0a1f')">KNOW MORE</a>
            </div>
          </div>
        </div>


        <button class="carousel-control-prev" type="button" data-bs-target="#ourProjects" data-bs-slide="prev">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="black" class="bi bi-chevron-left" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
          </svg>
          <!-- <span class="carousel-control-prev-icon" aria-hidden="true"></span> -->
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#ourProjects" data-bs-slide="next">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="black" class="bi bi-chevron-right" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
          </svg>
          <!-- <span class="carousel-control-next-icon" aria-hidden="true"></span> -->
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  </div>
</section>


<app-footer #textContent></app-footer>